import {
  Button,
  Flex,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useToast,
} from '@chakra-ui/react'
import Header from '../../../components/Header'
import { HeadingPages } from '../../../components/HeadingPages'
import InputGroup from '../../../components/InputGroup'
import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { baseURL } from '../../../services/api'
import { useMutation } from 'react-query'
import { Pagamento } from './Pagamento'

const schema = yup.object().shape({
  numeroUnico: yup.string().required('Campo obrigatório'),
})

export function PagamentoManual() {
  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    mode: 'onBlur',
  })

  const { data: dataClient, mutateAsync: getDataAsync } = useMutation(
    ['data-client'],
    async (data) => {
      const response = await baseURL.get(
        `/pedido/lista-dados-pedido/${data.numeroUnico}`
      )

      return response.data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  async function getDataClient(data) {
    await getDataAsync(data)
  }

  return (
    <>
      <HeadingPages name="Pagamento Manual" />
      <Flex
        flexDir="column"
        gap="1rem"
        maxWidth={'1300px'}
        w="full"
        mx="auto"
        justifyContent="center"
      >
        <Flex
          w="full"
          alignItems="center"
          justifyContent="center"
          maxW="300px"
          mx="auto"
          mt="2rem"
          as="form"
          onSubmit={handleSubmit(getDataClient)}
        >
          <InputGroup label="Numero único" {...register('numeroUnico')} />
          <Button
            colorScheme="blue"
            ml="4"
            isLoading={isSubmitting}
            type="submit"
          >
            OK
          </Button>
        </Flex>
        {dataClient && (
          <Table variant="striped" size="sm">
            <Thead>
              <Tr>
                <Th>Numero único</Th>
                <Th>Numero innovation</Th>
                <Th>Empresa - Razão social</Th>
                <Th>Empresa - CNPJ</Th>
                <Th>Razão social</Th>
                <Th>Cnpj</Th>
                <Th>Valor total</Th>
                <Th></Th>
              </Tr>
            </Thead>

            <Tbody>
              {dataClient?.map((item) => (
                <Pagamento key={item.numero_unico} {...item} />
              ))}
            </Tbody>
          </Table>
        )}
      </Flex>
    </>
  )
}
